<template>
  <div class="content-custom-pj" v-if="this.$store.get('systems@ApiKey')">
    <div>{{ this.chkUserModulRightCheck() }}</div>
    <div v-if="!ModulRightCheck">
      <b-alert show variant="danger"
        >ไม่มีสิทธิเข้าใช้งาน Manage Files Scan</b-alert
      >
    </div>

    <div v-if="ModulRightCheck">
      <h4>
        <v-icon name="file" class="icon-custom1"></v-icon> Manage Files Scan
      </h4>

      <b-alert show variant="primary" class="margin-bottom">
        <b-form @submit="onSubmitSearch" id="form-search-scan-file">
          <b-row>
            <b-col lg="2" class="margin-bottom-lg">
              <b-input-group size="sm">
                <!-- 
              <template v-slot:prepend>
                <b-form-checkbox
                  id="date-check"
                  name="date-check"
                  class="margin-top6px"
                ></b-form-checkbox>
              </template> -->
                <b-input-group-prepend is-text
                  ><b>วันที่</b></b-input-group-prepend
                >
                <template v-slot:append>
                  <date-picker
                    v-model="form.scan_date"
                    :lang="lang"
                    :first-day-of-week="1"
                    format="DD/MM/YYYY"
                    style="width:120px;"
                  ></date-picker>
                </template>
              </b-input-group>
            </b-col>

            <b-col lg="3" class="margin-bottom-lg">
              <b-input-group size="sm">
                <template v-slot:prepend>
                  <b-form-checkbox
                    id="files-type-check"
                    v-model="form.files_type_check"
                    name="files-type-check"
                    class="margin-top6px"
                  ></b-form-checkbox>
                </template>
                <b-input-group-prepend is-text
                  ><b>Files Type</b></b-input-group-prepend
                >

                <template>
                  <b-form-select
                    id="files-type"
                    :options="FilesScanTypeOptions"
                    v-model="form.files_type"
                    size="sm"
                  ></b-form-select>
                </template>
              </b-input-group>
            </b-col>

            <b-col lg="3" class="margin-bottom-lg">
              <b-input-group size="sm">
                <template v-slot:prepend>
                  <b-form-checkbox
                    id="hn-check"
                    v-model="form.hn_check"
                    name="hn-check"
                    class="margin-top6px"
                  ></b-form-checkbox>
                </template>
                <b-input-group-prepend is-text><b>HN</b></b-input-group-prepend>
                <b-form-input
                  id="hn"
                  name="hn"
                  type="number"
                  v-model="form.hn"
                  maxlength="9"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0,this.maxLength);"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    type="submit"
                    id="bt-search-scan-file"
                    variant="info"
                    >Search</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
        </b-form>
      </b-alert>
      <div>
        <FilesScans
          v-bind:my-search-status="this.SearchStatus"
          v-bind:my-scan-date="this.ScanDateSelect"
          v-bind:my-hn="this.hnSelect"
          v-bind:my-scan-type="this.filesScanTypeSelect"
        ></FilesScans>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue, options } from "vue-property-decorator";
import store from "@/store/store";
import axios from "axios";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";

import MenuIcon from "vue-material-design-icons/Menu.vue";
import RefreshIcon from "vue-material-design-icons/Refresh.vue";
import FilesScanType from "@/models/patientEMRs/FilesScanType";

import FilesScans from "@/components/Others/FilesScans/FilesScanDatas";

Vue.component("FilesScans", FilesScans);

Vue.component("menu-icon", MenuIcon);
Vue.component("refresh-icon", RefreshIcon);

@Component({
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      ModulRightCheck: false,
      scan_date: new Date(),
      lang: {
        // days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        months: [
          "ม.ค",
          "ก.พ",
          "มี.ค",
          "เม.ย",
          "พ.ค",
          "มิ.ย",
          "ก.ค",
          "ส.ค",
          "ก.ย",
          "ต.ค",
          "พ.ย",
          "ธ.ค"
        ],
        // months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ["next 1 days", "previous 1 days"],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range"
        }
      },
      form: {
        scan_date: new Date(),
        files_type_check: false,
        files_type: "",
        hn_check: false,
        hn: ""
      },
      FilesScanTypeOptions: [],
      filesScanTypeSelect: "",
      hnSelect: "",
      ScanDateSelect: "",
      SearchStatus: false
    };
  },
  component: {
    store,
    axios,
    thaiDatetime,
    pjFunctions,
    FilesScanType
  },
  mounted() {
    this.loadDataScanType();
  },
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
    setTimeout(() => {
      document.getElementById("bt-search-scan-file").click();
    }, 500);
  },
  watch: {},
  methods: {
    show(group, type = "", title = "", text = "") {
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },

    chkUserModulRightCheck() {
      if (this.$store.get("systems@LoginStatus")) {
        if (
          this.pjFunctionsFc.UserModulRightCheck(
            this.$store.get("systems@LoginData").accessright,
            "Admin"
          ) ||
          this.pjFunctionsFc.UserHOSxPRightCheck(
            this.$store.get("systems@LoginData").hos_accessright,
            "ADMIN"
          ) ||
          this.pjFunctionsFc.UserModulRightCheck(
            this.$store.get("systems@LoginData").accessright,
            "AdminOPDScan"
          )
        ) {
          this.ModulRightCheck = true;
        } else {
          this.ModulRightCheck = false;
        }
      } else {
        this.ModulRightCheck = false;
      }
    },
    loadDataScanType() {
      let ScrObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "FilesScanType", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey")
        })
        .then(function(response) {
          ScrObj.output = response.data;
          if (ScrObj.output.status === true) {
            FilesScanType.delete({
              where(record) {
                return record.id != "";
              }
            });

            let data = [];
            for (var val of ScrObj.output.result) {
              data.push({
                id: val.scan_opd_card_type,
                scan_opd_card_type: val.scan_opd_card_type,
                scan_opd_card_type_name: val.scan_opd_card_type_name,
                scan_opd_card_type_status: val.scan_opd_card_type_status,
                scan_opd_card_type_orderby: val.scan_opd_card_type_orderby,
                datas: val
              });
            }

            FilesScanType.insertOrUpdate({
              data
            });
          } else {
            if (ScrObj.output.ErrorMessage === "Data Not Found") {
              FilesScanType.delete({
                where(record) {
                  return record.id != "";
                }
              });
            }
          }
        })
        .catch(function(error) {
          ScrObj.output = error;
          console.log("FilesScanType : " + ScrObj.output);
        })
        .finally(function() {
          ScrObj.getDataScanType();
        });
    },
    getDataScanType() {
      let FilesScanTypeObj = FilesScanType.query()
        .where(record => record.scan_opd_card_type_status == "Y")
        .get();

      this.FilesScanTypeOptions.push({ value: "", text: "-- Files Type --" });

      if (FilesScanTypeObj.length > 0) {
        for (var val1 of FilesScanTypeObj) {
          this.FilesScanTypeOptions.push({
            value: val1.scan_opd_card_type,
            text: val1.scan_opd_card_type_name
          });
        }
      }
    },
    onSubmitSearch(evt) {
      evt.preventDefault();

      this.SearchStatus = false;

      let FormData = this.form;

      if (FormData.hn_check == true) {
        this.hnSelect = FormData.hn;
      } else {
        this.hnSelect = "";
      }

      if (FormData.files_type_check == true) {
        this.filesScanTypeSelect = FormData.files_type;
      } else {
        this.filesScanTypeSelect = "";
      }

      if (FormData.scan_date != "") {
        this.ScanDateSelect = this.thaiDatetimeFc.DateTimeToStrDate(
          FormData.scan_date
        );
      } else {
        this.ScanDateSelect = "";
      }

      if (this.ScanDateSelect != "" || this.hnSelect != "") {
        if (this.hnSelect != "") {
          this.ScanDateSelect = "";
        }

        setTimeout(() => {
          this.SearchStatus = true;
        }, 500);
      } else {
        this.SearchStatus = false;
      }
    }
  }
})
export default class FilesScan extends Vue {}
</script>


<style lang="scss">
</style>
